import React from 'react';
import PropTypes from 'prop-types';

import SuggestionField from './components/SuggestionField';
import SubmitAnnotationField from './components/SubmitAnnotationField';
import { ICON_PATH } from '../../constants';
import './SuggestionContainer.css';


class SuggestionContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      annotation: props.annotation,
      isSubmittable: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setSuggestion = this.setSuggestion.bind(this);
    this.updateAnnotation = this.updateAnnotation.bind(this);
  }

  setSuggestion(suggestion) {
    const { annotation } = this.state;
    this.updateAnnotation({
      ...annotation,
      comment: suggestion,
    });
  }

  updateAnnotation(updatedAnnotation) {
    const { annotation: stateAnnotation } = this.state;
    const annotation = { ...stateAnnotation, ...updatedAnnotation };
    const { comment } = annotation;
    this.setState({
      annotation,
      isSubmittable: /\S/.test(comment),
    });
  }

  async handleSubmit() {
    const { onSubmit } = this.props;
    const { annotation } = this.state;
    await onSubmit(annotation);
  }

  render() {
    const { onClose } = this.props;
    const { annotation: { comment }, isSubmittable } = this.state;

    return (
      <div className="annotator-suggestion">
        <div>
          <div className="annotator-heading">
            <img className="icon" src={`${ICON_PATH}/suggestion-icon-green.svg`} alt="Suggestion" />
            Leave a suggestion
          </div>
          <div className="annotator-subheading">
            This will not affect the GoCheck score.
          </div>
        </div>
        <SuggestionField
          onChange={this.setSuggestion}
          value={comment}
        />
        <SubmitAnnotationField
          isSubmittable={isSubmittable}
          onSubmit={this.handleSubmit}
          onCancel={onClose}
        />
      </div>
    );
  }
}


SuggestionContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  annotation: PropTypes.shape({
    id: PropTypes.number,
    comment: PropTypes.string,
  }).isRequired,
};


export default SuggestionContainer;
